import React from 'react';

import { createClassName } from 'utils/createClassName';

import './hoverableTooltipStyles.scss';

type Props = { text: string };

export const HoverableTooltipComponent: React.FC<Props> = (props) => {
  const { children, text } = props;

  const createHoverbaleTooltipClassName = createClassName('hoverableTooltip');

  const wrapperClassName = createHoverbaleTooltipClassName('wrapper');

  const contentClassName = createHoverbaleTooltipClassName('content');

  const popupClassName = createHoverbaleTooltipClassName('popup');

  return (
    <div className={wrapperClassName}>
      <div className={contentClassName}>{children}</div>
      <div className={popupClassName}>{text}</div>
    </div>
  );
};
